import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { isNumber } from 'lodash';
import { OnyxTooltipDirective } from '../../../directives/onyx-tooltip.directive';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import type { OnyxDataWidgetHeadingIcon } from '../interfaces';

@Component({
  selector: 'onyx-data-widget',
  imports: [OnyxIconComponent, TranslatePipe, OnyxTooltipDirective],
  templateUrl: './onyx-data-widget.component.html',
  styleUrl: './onyx-data-widget.component.scss',
})
export class OnyxDataWidgetComponent {
  public readonly supheading = input<string | null>(null);
  public readonly headingIcon = input<OnyxDataWidgetHeadingIcon | null>(null);
  public readonly color = input<
    | 'gray'
    | 'green'
    | 'red'
    | 'yellow'
    | 'orange'
    | 'blue'
    | 'violet'
    | 'sea-green'
  >('gray');
  public readonly selected = input(false);
  public readonly gap = input(8);
  public readonly padding = input<number | string>(12);
  public readonly showDivider = input(false);
  public readonly showHeadingAddon = input(false);
  public readonly clickable = input(false);

  protected readonly isNumber = isNumber;
}
